import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoutes = () => {
  const { email } = useAuth();
  const location = useLocation();

  if (email === null) {
    // Redirect to login page and save the location they tried to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If email is not null (user is authenticated), render the child routes
  return <Outlet />;
};

export default PrivateRoutes;